  <app-public-toolbar [showSignupLink]="true"></app-public-toolbar>
  <div fxLayout="row">
    <div  class="support-menu" fxHide.xs>
      <div fxLayout="row" fxLayoutAlign="space-between end">
        <img src="assets/images/tokn_logo.svg" alt="Tokentory Logo">
      </div>
      <mat-divider class="menu-divider"></mat-divider>
    </div>

    <div class="support-container">
      <div class="support-content">
        <h1 class="support-title">Contact Support</h1>
        <p>If you've run into issues using our platform or have any questions, please fill out and submit the form below and we will gladly get
          back to you in a timely manner.</p>
        <form [formGroup]="form">
          <mat-form-field class="support-form-field" floatLabel="always" color= "warn">
            <mat-label>please select a category which best fits your question.</mat-label>
            <mat-select formControlName="category" placeholder="" panelClass="dropdown-select-panel">
              <mat-option *ngFor="let category of categories" [value]="category.value">{{category.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="c-textarea" floatLabel="always" color= "warn">
            <mat-label >please describe your question/issue with in as much detail as possible
            </mat-label>
            <textarea matInput formControlName="description" rows="10"></textarea>
          </mat-form-field>

          <mat-form-field class="support-form-field" floatLabel="always" color= "warn">
            <mat-label>confirm email address</mat-label>
            <input matInput formControlName="email" placeholder="Enter your email">
            <mat-error *ngIf="form.get('email').hasError('invalid')">{{form.get('email').getError('invalid')}}</mat-error>
            <mat-error *ngIf="form.get('email').hasError('email')">Email is not valid.</mat-error>
            <mat-error *ngIf="form.get('email').hasError('whiteSpace')">This field can not be empty</mat-error>
          </mat-form-field>
          <br>
          <button class="submit" mat-raised-button color="primary" [disabled]="form.invalid"
            (click)="submit()" style="font-weight: 300; letter-spacing: 2px;">submit</button>
        </form>
      </div>
    </div>
  </div>
